import { Space, SpaceProps } from 'antd';
import { FC } from 'react';

export const ILSSpace: FC<SpaceProps> = (props) => {
  return <Space {...props} />;
};
